const integrationsActionTypes = {
  // fetch integration data
  FETCH_INTEGRATIONS_DATA: "FETCH_INTEGRATIONS_DATA",
  FETCH_INTEGRATIONS_DATA_SUCCESS: "FETCH_INTEGRATIONS_DATA_SUCCESS",
  FETCH_INTEGRATIONS_DATA_FAILURE: "FETCH_INTEGRATIONS_DATA_FAILURE",
};

export default integrationsActionTypes;
